import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPublishedCoursesByCategory } from "../../../controllers/coursesController";
import CourseByCategory from "./CourseByCategory";

const Categories = () => {
  const { cat } = useParams();
  const category = cat === "" || cat === null ? "top_menu" : cat;

  // const navigate = useNavigate();

  const [courses, setCourses] = useState({});

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getCoursesDataByCategory = async () => {
    if (category === "") return;
    // console.log({category});
    
    const FCourse = await getPublishedCoursesByCategory(category.trim());
    
    if (FCourse.category) {
      // console.log(FCourse);
      setCourses(FCourse);
    }
  };

  useEffect(() => {
    getCoursesDataByCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  //  console.log({courses});
  // useEffect(() => {
  //   if (category !== null && category !== "" && courses.length > 0) {
  //     document.getElementById(category).scrollIntoView();
  //   }
  // }, [category, courses]);

  return (
    <>
      {category === "" || category === null ? (
        <h3>Course Not Found!!!</h3>
      ) : (
        <CourseByCategory courses={courses} />
      )}
    </>
  );
};

export default Categories;
